import { useSelector } from 'react-redux';
import { EPaymentModalType } from 'reactApp/components/VkBuyModalWithSidebar/VkBuyModalWithSidebar.types';
import { BuySubscriptionSelectors } from 'reactApp/modules/buySubscription/buySubscription.module';
import { getFastCheckoutState } from 'reactApp/modules/fastCheckout/fastCheckout.selectors';
import { RootState } from 'reactApp/store';

export const useBuyState = ({ productId, type }) => {
    const {
        isLoading: isCheckoutLoading,
        hasError: checkoutError,
        checkoutLink,
    } = useSelector((state: RootState) => getFastCheckoutState(state, productId)) || {};

    const { link, hasError, isLoading } = useSelector(BuySubscriptionSelectors.getLink);

    if (type === EPaymentModalType.trial) {
        return {
            link: checkoutLink,
            isLoading: isCheckoutLoading,
            hasError: checkoutError,
        };
    }

    return {
        link,
        hasError,
        isLoading,
    };
};
